import React  from 'react';
import chengjiaokehuxinxijiaojiebiao from '../assets/img/chengjiaokehuxinxijiaojiebiao.png';

const Enclosure611 = () => 
    <div
        style={{
            WebkitTouchCallout:'none',  /*系统默认菜单被禁用*/
            MozUserSelect: 'none',  /*火狐*/
            WebkitUserSelect: 'none',  /*webkit浏览器*/
            msUserSelect: 'none',  /*IE10*/
            khtmlUserSelect: 'none',  /*早期浏览器*/
            userSelect: 'none',
        }}
     >
        <div style={{ textIndent: '2em' }}>
            <h3 style={{fontWeight:'bold'}}></h3>
            <img src={chengjiaokehuxinxijiaojiebiao} alt="" style={{
                width  : '90%',
                display: 'block',
                margin : '0 auto'
            }}/>
            <br/><br/>
        </div>
    </div>


export default Enclosure611;